import React, { PureComponent } from 'react';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { Search as SearchAdd } from '../../../common/mix-search/index';
import { connect } from 'react-redux';
import { REDUCER_NAME as MARKET_CALENDAR_CORPORATE } from './../reducer';
import { setQueryNewValue, changeCode } from './../reducer';
import ConstCommon from './../../../common/Const';

class Search extends PureComponent {
  clickItemSearch = currentSearch => {
    const { changeCode } = this.props;
    changeCode(currentSearch);
  };

  render() {
    const {
      listSearch,
      typeSearch,
      dateRangeOption,
      setQueryNewValue,
      disabled,
      lastTickerSelect,
    } = this.props;

    return (
      <SearchAdd
        disabled={disabled}
        listSearch={listSearch}
        listKeyFilter={[
          ConstCommon.listOrganization.TICKER,
          ConstCommon.listOrganization.ORGAN_SHORT_NAME,
        ]}
        typeSearch={typeSearch}
        dateRangeOption={dateRangeOption}
        // fetchListNewsData={fetchListNewsData}
        setQueryNewValue={setQueryNewValue}
        clickItemSearch={this.clickItemSearch}
        mainKey={'organCode'}
        sortKey={'ticker'}
        lastTickerSelect={lastTickerSelect}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    listSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
    lastTickerSelect: state[MARKET_CALENDAR_CORPORATE].textSearch,
  };
};

const mapDispatchToProps = {
  setQueryNewValue,
  changeCode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Search);
